import { invariant } from '@streem/toolbox';
import { find, map, mergeMap, mergeScan, switchMap } from 'rxjs/operators';
import { isUserWallItem, isWallItem } from './guards';
export function findInGroup(value) {
    return find(g => g.key === value);
}
export function filterByProperty(property, value) {
    return map(wallItems => wallItems.filter(item => item[property] === value));
}
export function excludeByProperty(property, value) {
    return map(wallItems => wallItems.filter(item => item[property] !== value));
}
export function accumulateAndMapWallEvents(type) {
    return accumulateAndTransformWallEvents(type);
}
export function accumulateAndTransformWallEvents(type, transform) {
    return mergeMap(g => g.pipe(mergeScan(async (acc, cur) => {
        const idx = acc.findIndex(i => cur.itemId === i.id);
        if (cur.type === 'DELETED') {
            invariant(idx >= 0, 'Tried to delete non-existent item');
            acc.splice(idx, 1);
            return acc;
        }
        let item = type
            ? mapWithMetadata(cur.item, type)
            : cur.item;
        if (transform) {
            item = await transform(item);
        }
        if (idx >= 0) {
            acc.splice(idx, 1, item);
        }
        else {
            acc.push(item);
        }
        return acc;
    }, [])));
}
export function mapWallItemFromWallItemEvents(type) {
    return switchMap(g => g.pipe(map(e => e.type === 'DELETED' ? undefined : type ? mapWithMetadata(e.item, type) : e.item)));
}
export function mapWithMetadata(item, type) {
    invariant(typeof item[type] === 'object');
    if (isWallItem(item)) {
        return Object.assign({
            id: item.id,
            ownerUserId: item.ownerUserId,
            ownerDeviceId: item.ownerDeviceId,
            clientCreatedAt: item.clientCreatedAt,
        }, item[type]);
    }
    else if (isUserWallItem(item)) {
        return Object.assign({
            id: item.id,
            ownerDeviceId: item.ownerDeviceId,
            clientCreatedAt: item.clientCreatedAt,
        }, item[type]);
    }
    throw new Error('Unable to determine WallItemType');
}
//# sourceMappingURL=utils.js.map